import { QUERY_KEYS } from "@/libraries/constant";
import type { GetGroupsParamSchema } from "@/schemas/group";
import { groupService } from "@/services";
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import { isEmpty } from "lodash";
import orderBy from "lodash/orderBy";

export const getGroupsQueryOptions = (param?: GetGroupsParamSchema) =>
	infiniteQueryOptions({
		queryKey: [QUERY_KEYS.GET_GROUPS, ...(isEmpty(param) ? [] : [param])],
		initialPageParam: 1,
		queryFn: ({ pageParam }) =>
			groupService.list({ ...param, page: pageParam }),
		getNextPageParam: (lastPage) => lastPage?.meta?.next_page,
		select: (data) => {
			const groups = data.pages?.flatMap((page) => page.groups) || [];
			if (!groups.length) return [];
			return orderBy(groups, (group) => group.last_message?.updated_at, "desc");
		},
	});

export const getGroupsMetaQueryOptions = (param?: GetGroupsParamSchema) =>
	queryOptions({
		queryKey: [QUERY_KEYS.GET_GROUPS_FLAT, ...(isEmpty(param) ? [] : [param])],
		queryFn: () => groupService.list({ ...param, page: param?.page ?? 1 }),
	});

export const getGroupQueryOptions = (id: any, options?: { enabled: boolean }) =>
	queryOptions({
		queryKey: [QUERY_KEYS.GET_GROUP, id],
		queryFn: () => groupService.get(id),
		enabled: options?.enabled ?? !!id,
		...options,
	});
